export const IDENTIFY_FILTER_HISTORY = 'IDENTIFY_FILTER_HISTORY'
export const IDENTIFY_FILTER_HISTORY_ERR = 'IDENTIFY_FILTER_HISTORY_ERR'
export const RESET_IDENTIFY_FILTER_HISTORY = 'RESET_IDENTIFY_FILTER_HISTORY'